export default function noNetworkAction(history){
    history.push('/networkError')
}

